import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Grid,
  Alert,
} from '@mui/material';
import { apiService } from '../services/api';

function HomePage() {
  const [healthStatus, setHealthStatus] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const checkHealth = async () => {
      try {
        const status = await apiService.getHealth();
        setHealthStatus(status);
      } catch (err) {
        setError('Unable to connect to backend API');
        console.error(err);
      }
    };
    checkHealth();
  }, []);

  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Welcome to Dialog Transcription Application
      </Typography>
      <Typography variant="body1" paragraph>
        Convert your audio interviews into accurate, searchable text transcripts using
        state-of-the-art AI transcription services.
      </Typography>

      <Grid container spacing={3} sx={{ mt: 2 }}>
        <Grid item xs={12} md={4}>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                📤 Upload Audio
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Upload WAV files up to 600MB for transcription
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={4}>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                🎯 Context Enhancement
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Add context and domain-specific vocabulary for better accuracy
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={4}>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                ✏️ Interactive Editing
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Edit transcripts with synchronized audio playback
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {error && (
        <Alert severity="error" sx={{ mt: 3 }}>
          {error}
        </Alert>
      )}

      {healthStatus && (
        <Alert severity="success" sx={{ mt: 3 }}>
          Backend API Status: {healthStatus.status} (v{healthStatus.version})
        </Alert>
      )}
    </Box>
  );
}

export default HomePage;
